import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
export function UrgencyBar() {
  const [spots, setSpots] = useState(7);
  const [time, setTime] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  // Countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Simulate spots decreasing
  useEffect(() => {
    const timer = setInterval(() => {
      setSpots(prev => prev > 2 ? prev - 1 : prev);
    }, 60000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 shadow-lg" style={{
    backgroundColor: '#FF3131'
  }} data-id="element-252">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col md:flex-row items-center justify-center text-center gap-3 md:gap-5" data-id="element-253">
        <div className="flex items-center gap-2 text-white font-semibold text-sm sm:text-base" data-id="element-254">
          <AlertTriangle className="w-5 h-5 text-white animate-pulse flex-shrink-0" data-id="element-255" />
          <p data-id="element-256">
            ⚠️ <span className="font-bold" data-id="element-257">CRITICAL UPDATE:</span> The FICO 10T
            Algorithm just updated. Old dispute letters are now being rejected.{' '}
            <span className="font-extrabold uppercase" data-id="element-258">
              ONLY {spots} COPIES LEFT AT $47 TODAY.
            </span>
          </p>
        </div>

        {/* Countdown Timer */}
        <div className="flex items-center gap-1 bg-black/40 px-4 py-1.5 rounded-lg border border-white/20 flex-shrink-0" data-id="element-259">
          <span className="text-white font-bold text-xs uppercase tracking-wider mr-2" data-id="element-260">
            Expires:
          </span>
          <div className="flex items-center gap-1 font-mono text-white font-bold text-lg" data-id="element-261">
            <span className="bg-black/50 px-2 py-0.5 rounded" data-id="element-262">
              {pad(time.hours)}
            </span>
            <span className="animate-pulse" data-id="element-263">:</span>
            <span className="bg-black/50 px-2 py-0.5 rounded" data-id="element-264">
              {pad(time.minutes)}
            </span>
            <span className="animate-pulse" data-id="element-265">:</span>
            <span className="bg-black/50 px-2 py-0.5 rounded" data-id="element-266">
              {pad(time.seconds)}
            </span>
          </div>
        </div>
      </div>
    </div>;
}